<template>
  <modal
    :size="size" 
    @close-modal="closeModal"
    @close="closeModal"
    :submit="false"
    :labels="{cancel: 'Cancelar'}"
    class="is-share"
  >
    <div slot="header">
      Compartilhar
    </div>
    <div slot="content">
      <div class="list-block -small Compartilhar">
          <a :href="facebook + url" target="_blank" class="item Btn__compartilhar -fb" @click.prevent="shareFacebook">
            <icon name="fb" size="medium" class="-left"></icon>
            Facebook
          </a>
          <a v-if="isMobile" :href="wppUrl" data-action="share/whatsapp/share" class="item Btn__compartilhar -wpp">
            <icon name="wpp" size="medium" class="-left"></icon>
            WhatsApp
          </a>
          <a :href="twitterUrl" target="_blank" class="item Btn__compartilhar -twt" @click.prevent="shareTwitter">
            <icon name="twt" size="medium" class="-left"></icon>
            Twitter
          </a>
          <button class="item Btn__compartilhar -copy" ref="copyBtn" :data-clipboard-text="url">
            <icon name="copy" size="medium" class="-left"></icon>
            {{ clipboardLabel }}
          </button>
      </div>
    </div>
  </modal>
</template>

<script>
  import Clipboard from 'clipboard';
  import isMobile from 'ismobilejs';
  export default {
    props: {
      size: {
        default: 'tiny',
      },
      url: {
        default: window.location.href,
      }
    },
    data() {
      return {
        twitter: 'http://twitter.com/share?',
        facebook: 'https://www.facebook.com/sharer.php?u=',
        clipboard: undefined,
        copied: false,
        isMobile: isMobile.any
      }
    },
    mounted() {
      this.clipboard = new Clipboard(this.$refs.copyBtn);
      this.clipboard.on('success', () => {
        this.copied = true;
        this.clipboard.destroy();
        setTimeout(() => {
          EventBus.$emit('close-modal');
          EventBus.$emit('modal-close');
        }, 300)
      });

    },
    computed: {
      twitterUrl() {
        return `${this.twitter}text=${document.title.split('|').join('-')}&via=SiteEscavador&url=${this.url}`;
      },
      wppUrl() {
        return `whatsapp://send?text=${document.title} - ${this.url}`;
      },
      clipboardLabel() {
        return this.copied ? 'Link Copiado' : 'Copiar Link'
      }
    },
    methods: {
      closeModal() {
        this.$emit('close-modal');
      },
      share(url, title) {
        window.open(
          url,
          title,
          'height=400, width=670, top=' + ( window.innerHeight / 2 - 200) + ', left=' + (window.innerWidth / 2 - 335) + ', toolbar=no, menubar=no, scrollbars=yes, resizable=yes'
        );
        window.setTimeout(() => {
          EventBus.$emit('close-modal');
          EventBus.$emit('modal-close');
        }, 300);
      },
      shareFacebook() {
        this.share(
          this.facebook + this.url,
          'Compartilhe no Facebook'
        );
      },
      shareTwitter() {
        this.share(
          `${this.twitter}text=${document.title.split('|').join('-')}&url=${this.url}&via=SiteEscavador`,
          'Compartilhe no Twitter'
        );
      }
    }
  }
</script>

<style lang="stylus">
    .Compartilhar
      & > .item
        border-bottom 1px solid #eee
        display flex
        align-items center
        justify-content flex-start
        padding 0.5rem
        cursor pointer
      & > .item:last-child
        border-bottom 0
        font-size inherit
    .Compartilhar > .item .svg-icon
      margin-right 12px
      height 20px
      width 24px
      fill rgba(0, 0, 0, 0.4)
    .Btn__compartilhar
      display flex
      align-items center
      text-align left
      border none
      background none
      width 100%
      color #898989
      &:hover
        color #333
        &.-copy > .svg-icon
          fill #333
        &.-twt > .svg-icon
          fill #4099ff
        &.-gplus > .svg-icon
          fill #d34836
        &.-fb > .svg-icon
          fill #3B5998
        &.-wpp > .svg-icon
          fill #2ab200
      &:hover &:active
        outline 1px dotted #ddd
        outline-offset 2px
</style>
